/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f122n59{align-items:center;}
.f4d9j23{justify-content:center;}
.f17mccla{text-align:center;}
.f1noh358{row-gap:var(--spacingVerticalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1hfhel7{padding-block:var(--spacingVerticalXXXL);}
.fnsi1rm{padding-inline:var(--spacingHorizontalXXL);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkfq4zb{color:var(--colorNeutralForeground2);}
.f1ejnbxg{inline-size:88px;}
.f1sif4mv{block-size:80px;}
.fqonovg{font-size:44px;}
.f16muhyy{color:var(--colorBrandForeground1);}
.f1ac3ntu{background-color:var(--bfTrack);}
.fyvd8f1{border-start-start-radius:44px;}
.f1d6f24m{border-start-end-radius:44px;}
.f1pqui0w{border-end-start-radius:var(--borderRadiusSmall);}
.fgs7pz1{border-end-end-radius:var(--borderRadiusSmall);}
.fsxozpy{border-block-end-width:3px;}
.f1p2dij1{border-block-end-style:solid;}
.f11m8539{border-block-end-color:var(--bfFlowLine);}
.fd1mfrk{padding-block-start:var(--spacingVerticalS);}
.fg38ndl{font-size:18px;}
.f336tjw{line-height:28px;}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.f19n0e5{color:var(--colorNeutralForeground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f6mdc4w{max-width:460px;}
.f11d4kpn{color:var(--colorNeutralForeground3);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fni485r{flex-wrap:wrap;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
.f4zdp0h{margin-block-start:var(--spacingVerticalS);}
/** @griffel:css-end **/